import { CommonModule } from "@angular/common";
import { AfterViewChecked, Component, Inject, OnInit } from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { FormFieldComponent } from "@pishgamrayan/ng-form-kit";

import { ShareDirectivesModule } from "src/app/core/directives/directives.module";
import { BaseFormPageComponent } from "src/app/pages/shared/base/components/base-form-page.component";
import { FormBtnsModule } from "src/app/shared/global/form-btns/form-btns.module";
import { ModalTitleComponent } from "src/app/shared/global/modal-title/modal-title.component";
import { MaterialModule } from "src/app/shared/modules/material/material.module";

@Component({
    selector: "app-polygon-title-form",
    templateUrl: "./polygon-title-form.component.html",
    imports: [
        CommonModule,
        MaterialModule,
        NgbModule,
        FormsModule,
        ShareDirectivesModule,
        ReactiveFormsModule,
        TranslateModule,
        FormBtnsModule,
        FormFieldComponent,
        ModalTitleComponent,
    ]
})
export class PolygonTitleFormComponent
  extends BaseFormPageComponent
  implements OnInit, AfterViewChecked
{
  //#region Properties
  polygonTitle: string = "";
  //#endregion

  constructor(
    private dialogRef: MatDialogRef<PolygonTitleFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.formPageConfig.isEditMode = data?.isEdit;
  }

  ngOnInit() {
    this.initForm();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl("", [Validators.required]),
    });
  }

  onClose() {
    this.dialogRef.close({ isSuccess: false });
  }

  onSuccess() {
    this.dialogRef.close({ isSuccess: true, title: this.polygonTitle });
    this.unSubs();
  }
}
